import {Variant} from "../../models/product";
import {Component} from "preact";
import {i18nService} from "../../services/i18n-service";
import {icons} from "../icons";
import styles from './style.module.scss';

interface Props {
  variant: Variant;
}

interface State {
  shootingSizes: boolean;
}

export class ShootingSize extends Component<Props, State> {

  constructor() {
    super();
    this.toggleSizeInfo = this.toggleSizeInfo.bind(this);
    this.handleSizeKeyPress = this.handleSizeKeyPress.bind(this);
  }

  state: State = {
    shootingSizes: false,
  };

  componentDidMount(): void {

  }

  private toggleSizeInfo() {
    this.setState((prevState) => ({
      shootingSizes: !prevState.shootingSizes,
    }));
  }

  private handleSizeKeyPress(e: KeyboardEvent) {
    if (e.key == "Enter") {
      this.toggleSizeInfo();
    }
  }

  render() {
    const {variant} = this.props;
    const {shootingSizes} = this.state;

    if (!variant.shooting_product_size || !variant.shooting_model_size) {
      return null;
    }

    return (
      <>
        <div className={styles['size-container']}>
          <div
            className={styles['size-title']}
            onClick={this.toggleSizeInfo}
            onKeyPress={this.handleSizeKeyPress}
            tabIndex={0}
            aria-label={i18nService.translate("detail_view_size_information")}
          >
            <span>{i18nService.translate("detail_view_size_information")}</span>
            <span className={styles['toggle-arrow']}>
            {shootingSizes ? icons.renderChevronUpIcon() : icons.renderChevronDownIcon()}
          </span>
          </div>

          {shootingSizes && (
            <div className={styles['details']}>
              <div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18nService.translate(
                      "detail_view_model_size_description",
                      `${variant.shooting_model_size}`,
                      `${variant.shooting_product_size}`
                    )
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className={styles['separator']}></div>
      </>
    );
  }
}